module.exports = __webpack_public_path__ + "img/toro-canary.4ffaa8cb.png";